// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartTypeRegistry.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartTypeRegistry component
 */
import ReportPartTypeManager from 'Izenda.ReportPartTypeManager';
import localizer from 'share/localization/Izenda.Localizer';
import { PERMISSION_KEY } from 'logic/data/Izenda.AuthorizationConstants';
import { LICENSE_KEY } from 'logic/data/Izenda.LicenseCheckerConstants';
import { REPORT_PART_TYPE } from 'logic/data/Izenda.ReportDesignerConstants';

const REPORT_PART_TYPES = [
  {
    key: 'chart',
    value: REPORT_PART_TYPE.Chart,
    icon: 'icon-chart-bar',
    get label() {
      return localizer.getText('COMMON_LABEL_CHART');
    },
    haveDashboardScroll: false,
    component: {
      BackSide: require('./Izenda.ReportPartBackSideConfiguration'),
      FrontSide: require('./ReportPartChart/Izenda.ChartFrontSide')
    },
    properties: {
      reportPart: require('./Izenda.ReportPartPropsSchema'),
      fieldProps: require('./ReportPartChart/Izenda.ChartFieldPropsSchema')
    },
    permissions: [PERMISSION_KEY.ReportsReportPartTypesChart],
    licenseKey: LICENSE_KEY.Charting
  },
  {
    key: 'form',
    value: REPORT_PART_TYPE.Form,
    icon: 'icon-doc-text',
    get label() {
      // for size of container
      return localizer.getText('COMMON_LABEL_FORM');
    },
    haveDashboardScroll: true,
    component: {
      BackSide: require('./ReportPartForm/Izenda.ReportPartFormBackSide'),
      FrontSide: require('./ReportPartForm/Izenda.ReportPartFormFrontSide')
    },
    properties: {
      reportPart: require('./ReportPartForm/Izenda.ReportPartPropsFormSchema'),
      fieldProps: require('./ReportPartForm/Izenda.ReportPartFieldPropsSchemaForm')
    },
    permissions: [PERMISSION_KEY.ReportsReportPartTypesForm],
    licenseKey: LICENSE_KEY.Form
  },
  {
    key: 'gauge',
    value: REPORT_PART_TYPE.Gauge,
    icon: 'icon-gauge',
    get label() {
      // for size of container
      return localizer.getText('COMMON_LABEL_GAUGE');
    },
    component: {
      BackSide: require('./Izenda.ReportPartBackSideConfiguration'),
      FrontSide: require('./ReportPartGauge/Izenda.GaugeFrontSide')
    },
    properties: {
      reportPart: require('./Izenda.ReportPartPropsSchema'),
      fieldProps: require('./ReportPartGauge/Izenda.GaugeFieldPropsSchema')
    },
    permissions: [PERMISSION_KEY.ReportsReportPartTypesGauge],
    licenseKey: LICENSE_KEY.Charting
  },
  {
    key: 'grid',
    value: REPORT_PART_TYPE.Grid,
    icon: 'icon-grid',
    get label() {
      // for size of container
      return localizer.getText('COMMON_LABEL_GRID');
    },
    haveDashboardScroll: true,
    width: 0,
    height: 0,
    component: {
      BackSide: require('./ReportPartGrid/Izenda.ReportPartGridBackSideConfiguration'),
      FrontSide: require('./ReportPartGrid/Izenda.ReportPartGridFrontSide')
    },
    properties: {
      reportPart: require('./ReportPartGrid/Izenda.ReportPartPropsGridSchema'),
      fieldProps: require('./ReportPartGrid/Izenda.ReportPartFieldPropsSchemaGrid')
    }
  },
  {
    key: 'map',
    value: REPORT_PART_TYPE.Map,
    icon: 'icon-globe',
    get label() {
      // for size of container
      return localizer.getText('COMMON_LABEL_MAP');
    },
    haveDashboardScroll: false,
    component: {
      BackSide: require('./Izenda.ReportPartBackSideConfiguration'),
      FrontSide: require('./ReportPartMap/Izenda.MapFrontSide')
    },
    properties: {
      reportPart: require('./Izenda.ReportPartPropsSchema'),
      fieldProps: require('./ReportPartMap/Izenda.MapFieldPropsSchema')
    },
    permissions: [PERMISSION_KEY.ReportsReportPartTypesMap],
    licenseKey: LICENSE_KEY.Maps
  },
  {
    key: 'kpi',
    value: REPORT_PART_TYPE.KPI,
    icon: 'icomoon-looks_one u_icon-marginLeftRight',
    get label() {
      // for size of container
      return localizer.getText('COMMON_LABEL_KPI');
    },
    component: {
      BackSide: require('./Izenda.ReportPartBackSideConfiguration'),
      FrontSide: require('./ReportPartKPI/Izenda.ReportPartKPIGrid')
    },
    properties: {
      reportPart: require('./Izenda.ReportPartPropsSchema'),
      fieldProps: require('./ReportPartKPI/Izenda.KPIFieldPropsSchema')
    },
    permissions: [PERMISSION_KEY.ReportsReportPartTypesKPI],
    licenseKey: LICENSE_KEY.Charting
  }
]; // for size of container

/**
 * Option object
 */
export default {
  REPORT_PART_TYPES,

  /**
   * Initialize ReportPartTypes to ReportPartTypeManager registry
   */
  initRegistry() {
    REPORT_PART_TYPES.forEach(reportPart => {
      ReportPartTypeManager.registerReportPartType(reportPart, reportPart.key);
    });
  }
};



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/Izenda.ReportPartTypeRegistry.js